import * as Sentry from "@sentry/react";

export { Sentry };

export function initSentry() {
  if (!import.meta.env.VITE_SENTRY_DSN) return;
  console.debug(
    "Initializing Sentry with DSN:",
    import.meta.env.VITE_SENTRY_DSN,
  );

  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    release: import.meta.env.SENTRY_RELEASE?.id,
    environment: import.meta.env.VITE_ENV ?? "dev",
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],
    // Capture 100% of transactions in dev, 50% in prod
    tracesSampleRate: import.meta.env.VITE_ENV === "prod" ? 0.5 : 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
}
